
import styled from 'styled-components';
import * as Material  from '@material-ui/core';

export const ItemsSubtitle = styled.p`
    font-weight: bold;
    padding-right: 10px;
    padding-bottom: 0;
    margin-bottom: 0;
`;

export const ModalBody = styled.div`
    margin: 20px auto;
    position: relative;
    width: 1000px;
    max-width: 90%;
    background-color: white;
    -webkit-box-shadow: 5px 5px 15px 5px #000000; 
    box-shadow: 5px 5px 15px 5px #000000;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
    padding: min(20px,4%) min(85px,4%);
    padding-bottom: 50px;
`;

export const ModalCloseButton = styled(Material.Button)`
    position: absolute;
    right: min(15px,5%);
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
    height: 30px;
    width: 30px;
    min-width: 30px;
    max-width: 30px;
    overflow: visible;
    display: block;
    line-height: 6px;
    padding: 0;
    text-align: center;
`;

export const SessionTitle = styled.h4`
  margin: 10px 0 30px;
  text-align: left;
`;

export const SessionContent = styled.div`
  margin: 10px 0 45px 0;
`;

export const ChartSubtitle = styled.div`
  font-size: 10pt;
  font-weight: bold;
  text-align: center;
`;
